var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StyledButtonStyle;
(function (StyledButtonStyle) {
    StyledButtonStyle[StyledButtonStyle["Green"] = 0] = "Green";
    StyledButtonStyle[StyledButtonStyle["Gray"] = 1] = "Gray";
})(StyledButtonStyle || (StyledButtonStyle = {}));
export var StyledButton = function (_a) {
    var children = _a.children, text = _a.text, onClick = _a.onClick, className = _a.className, disabled = _a.disabled, style = _a.style;
    var buttonStyle = "";
    switch (style) {
        case StyledButtonStyle.Gray:
            buttonStyle =
                "text-white hover:text-black-400 bg-black-1000 active:text-black-600";
            break;
        case StyledButtonStyle.Green:
        default:
            buttonStyle =
                "text-black-1200 hover:text-black-1000 bg-green hover:bg-green/80 active:bg-green/60";
    }
    if (disabled) {
        buttonStyle = "bg-black-1000 text-black hover:text-black-600";
    }
    return (_jsxs("button", __assign({ onClick: onClick, className: "font-N8 whitespace-pre w-fit px-[20px] py-[13px] rounded-[10px] ".concat(className !== null && className !== void 0 ? className : "", " ").concat(buttonStyle), disabled: disabled }, { children: [text, children] })));
};
